import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-regular-svg-icons';
import { Badge } from 'src/client/components/ui/Badge';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { CardInformation } from 'src/client/components/ui/CardInformation';
import { Card } from 'src/client/components/ui/Card';
import { Link } from 'react-router-dom';
import GirdCardMenuOverlay from '../../GridCardMenuOverlay';
import { ModelSubscriptionModal } from '../../../../components/modals/ModelSubscriptionModal';
import { CardMedia } from 'src/client/components/ui/CardMedia';

const Wrapper = styled.div`
  &:not(.menu-opened) {
    &:hover {
      .card-menu-overlay {
        opacity: 1;
      }
    }
  }

  .card-menu-overlay {
    transition: 0.3s opacity;
    opacity: 0;
    color: #fff;
  }

  .card-media {
    overflow: hidden;

    a {
      display: block;

      img {
        aspect-ratio: 229 / 354;
      }
    }
  }
`;

type Props = {
  name: string;
  url: string;
  isBlurred: boolean;
  imgSrc: string;
  imgAlt: string;
  ratingAverage?: string | number;
  views?: string | number;
  isFavorited?: boolean;
  onFavorite: () => void;
};
export const ModelGridCard = (props: Props) => {
  const { name, url, imgSrc, imgAlt, ratingAverage = 0, isBlurred, isFavorited = false, views = 0, onFavorite } = props;

  const [isOpen, setOpen] = useState(false);
  const [showFollowModal, setFollowModalVisibility] = useState(false);

  const showRatingAverage = parseInt(ratingAverage as string, 10) > 0;

  return (
    <Wrapper className={`grid-card-wrapper ${isOpen ? 'menu-opened' : ''}`}>
      <Card>
        <CardMedia
          url={url}
          imgSrc={imgSrc}
          lazy
          animate
          altText={imgAlt}
          badges={[
            ...(views ? [<Badge key="views" text={views} icon={<FontAwesomeIcon icon={faEye} />} />] : []),
            ...(showRatingAverage
              ? [<Badge key="rating" text={ratingAverage} icon={<FontAwesomeIcon icon={faStar} />} />]
              : []),
          ]}
          blurred={isBlurred}
        >
          <GirdCardMenuOverlay
            onFavorite={() => (!isFavorited ? setFollowModalVisibility(true) : onFavorite())}
            isFavorited={isFavorited}
            setOpen={setOpen}
            isOpen={isOpen}
          />
        </CardMedia>
        <CardInformation className="card-info-1" title={<Link to={url}>{name}</Link>} />
      </Card>
      {isOpen && (
        <ModelSubscriptionModal
          showModal={showFollowModal}
          onToggleFavor={onFavorite}
          hideModal={() => setFollowModalVisibility(false)}
        />
      )}
    </Wrapper>
  );
};
